import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Paper,
  Alert,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import { apiServices } from "../../../services/apiServices";
import Swal from 'sweetalert2';
import DescriptionIcon from '@mui/icons-material/Description';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const SectionHeader = ({ number, title }) => (
  <Box sx={{ mb: 2 }}>
    <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#333', fontSize: '0.85rem', letterSpacing: 1 }}>
      {String(number).padStart(2, '0')}. {title}
    </Typography>
    <Divider sx={{ mt: 1 }} />
  </Box>
);

const EntityReferralStatistics = ({ userId }) => {
  const [paidAmount, setPaidAmount] = useState("");
  const [remarks, setRemarks] = useState("");
  const [receiptFile, setReceiptFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });
  const [payoutHistory, setPayoutHistory] = useState([]);
  const [pendingAmount, setPendingAmount] = useState("0.00");
  const [currentMonthReferrals, setCurrentMonthReferrals] = useState("0");
  const [currentMonthAmount, setCurrentMonthAmount] = useState("0.00");
  const [totalReferrals, setTotalReferrals] = useState("0");
  const [referralAmount, setReferralAmount] = useState("0.00");
const [universalReferralCount, setUniversalReferralCount] = useState("0");
const [totalReferralAmount, setTotalReferralAmount] = useState("0.00");
const [auditHistory, setAuditHistory] = useState([]);
const [previewFile, setPreviewFile] = useState(null);
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;
  const currentYear = currentDate.getFullYear();
const [originalReferralAmount, setOriginalReferralAmount] = useState("0.00");
  const months = [
    { value: "1", label: "January" }, { value: "2", label: "February" },
    { value: "3", label: "March" }, { value: "4", label: "April" },
    { value: "5", label: "May" }, { value: "6", label: "June" },
    { value: "7", label: "July" }, { value: "8", label: "August" },
    { value: "9", label: "September" }, { value: "10", label: "October" },
    { value: "11", label: "November" }, { value: "12", label: "December" }
  ];

  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `.swal2-container { z-index: 999999 !important; }`;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  useEffect(() => {
    console.log("userId", userId)
    if (userId) fetchPayoutSummary();
     fetchReferralSummary();
      fetchReferralPayoutDetails();
  }, [userId]);
const fetchReferralSummary = async () => {
  try {
    const response = await apiServices.postAPI('admin/referral-summary', {
      peacekeeper_id: userId
    });

    console.log("Referral Summary Response:", response.data);

    if (response.data.success) {
 
 const data = response.data.summary || {};
setUniversalReferralCount(data.total_referrals || "0");
setTotalReferralAmount(data.referral_amount || "0.00");

// Find current month's referral_count_value from yearly_data
const allRecords = (response.data.yearly_data || [])
  .flatMap(y => y.records || [])
  .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

const currentMonthRecord = allRecords.find(
  item => Number(item.month) === currentMonth && Number(item.year) === currentYear
);

// Also set referral amount from latest current month record
if (currentMonthRecord) {
  setCurrentMonthReferrals(currentMonthRecord.referral_count_value || "0");
  setCurrentMonthAmount(currentMonthRecord.referral_amount || "0.00");
   setOriginalReferralAmount(currentMonthRecord.referral_amount || "0.00");
}
    } else {
      console.error("Referral summary API failed:", response.data.message);
    }
  } catch (error) {
    console.error("fetchReferralSummary error:", error.message);
  }
};
const fetchReferralPayoutDetails = async () => {
  try {
    const response = await apiServices.postAPI('admin/get-referral-payout-details', {
      peacekeeper_id: userId
    });

    console.log("Referral Payout Details Response:", response.data);

    if (response.data.success) {
     const data = response.data.data || [];
const sorted = [...data].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
setAuditHistory(sorted);
    } else {
      console.error("Referral payout details API failed:", response.data.message);
    }
  } catch (error) {
    console.error("fetchReferralPayoutDetails error:", error.message);
  }
};
  const fetchPayoutSummary = async () => {
    try {
      console.log("=== FETCH PAYOUT SUMMARY START ==="); // Debug log
      console.log("Selected Entity ID:", userId); // Debug log
      console.log("Current Year:", currentYear, "Current Month:", currentMonth); // Debug log
      
      if (!userId) {
        console.log("No userId provided, skipping API call"); // Debug log
        return;
      }
      
      // Test with hardcoded ID first
      const testId = "IN-0000021-IAPM";
      console.log("Testing with hardcoded ID:", testId); // Debug log
      
      const response = await apiServices.postAPI('admin/get-payout-summary', {
        peacekeeper_id: userId, 
        year: currentYear,
        month: currentMonth
      });
      console.log("1. Full response:", response);
    console.log("2. response.data:", response.data);
    console.log("3. response.data.data:", response.data.data);
    console.log("4. userId:", userId);
    console.log("5. Sending payload:", { peacekeeper_id: userId });
      
      if (response.data.success) {
        const historyData = response.data.data || [];
        console.log("History Data:", historyData); // Debug log
        setPayoutHistory(historyData);
   const currentMonthData = historyData
  .filter(item => Number(item.month) === currentMonth && Number(item.year) === currentYear)
  .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];
        console.log("Current Month Data:", currentMonthData); // Debug log
        console.log("Current Month:", currentMonth, "Current Year:", currentYear); // Debug log
         historyData.forEach((item, i) => {
        console.log(`8. item[${i}]:`, item);
        console.log(`   month: ${item.month} (type: ${typeof item.month})`);
        console.log(`   year: ${item.year} (type: ${typeof item.year})`);
        console.log(`   currentMonth: ${currentMonth} (type: ${typeof currentMonth})`);
        console.log(`   currentYear: ${currentYear} (type: ${typeof currentYear})`);
        console.log(`   match: ${Number(item.month) === currentMonth && Number(item.year) === currentYear}`);
      });
        
        if (currentMonthData) {
          setPendingAmount(currentMonthData.balance || "0.00");
          setCurrentMonthReferrals(currentMonthData.referrals || "0");
          setCurrentMonthAmount(currentMonthData.refferal_amount || "0.00");
          console.log("Set values:", {
            pendingAmount: currentMonthData.balance,
            currentMonthReferrals: currentMonthData.referrals,
            currentMonthAmount: currentMonthData.refferal_amount
          }); // Debug log
        } else {
          setPendingAmount("0.00");
          setCurrentMonthReferrals("0");
          setCurrentMonthAmount("0.00");
          console.log("No current month data found, using defaults"); // Debug log
          console.log("Available months in data:", historyData.map(item => `${item.month}/${item.year}`)); // Debug log
        }
      } else {
        console.error("API call failed:", response.data.message);
      }
      console.log("=== FETCH PAYOUT SUMMARY END ==="); // Debug log
    } catch (error) {
      console.error("Failed to fetch payout summary:", error);
      console.error("Error details:", error.message); // Debug log
    }
  };

 const handleSave = async () => {
  if (!paidAmount.trim()) {
    setAlert({ show: true, type: "error", message: "Please enter the paid referral amount." });
    return;
  }
  const paidNum = parseFloat(paidAmount);
  const pendingNum = parseFloat(pendingAmount);
  if (paidNum > pendingNum) {
    setAlert({ show: true, type: "error", message: `Paid amount cannot exceed pending amount of $${pendingAmount}.` });
    return;
  }
  if (!remarks.trim()) {
    setAlert({ show: true, type: "error", message: "Please enter remarks/transaction ID." });
    return;
  }
  if (!receiptFile) {
    setAlert({ show: true, type: "error", message: "Please upload a receipt file." });
    return;
  }

  setLoading(true);
  setAlert({ show: false, type: "", message: "" });

  try {
    const totalPaid = (parseFloat(pendingAmount) - parseFloat(paidAmount)).toFixed(2);
    const balance = Math.max(0, parseFloat(pendingAmount) - parseFloat(paidAmount)).toFixed(2);

    const formData = new FormData();
    formData.append('peacekeeper_id', userId);                  // who is being paid
    formData.append('year', currentYear.toString());
    formData.append('month', currentMonth.toString());
formData.append('paid_amount', (parseFloat(paidAmount) * 100).toString());    formData.append('remarks', remarks);                        // Audit Remark / TXN ID
    formData.append('receipt_file', receiptFile);               // Attachment file
formData.append('payout_status', getPayoutStatus());
formData.append('status', getPayoutStatus());
    formData.append('refferal_amount', currentMonthAmount);     // total referral amount for the month
    formData.append('pending_amount', pendingAmount);           // amount pending before this payment
    formData.append('total_paid_amount', totalPaid);            // remaining after payment
    formData.append('balance', balance);                        // balance after payment

    console.log("Submitting payout payload:", {
      peacekeeper_id: userId,
      paid_amount: paidAmount,
      remarks,
      refferal_amount: currentMonthAmount,
      pending_amount: pendingAmount,
      total_paid_amount: totalPaid,
      balance,
    });

    const response = await apiServices.postAPI('admin/referral-payout', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    if (response.data.success) {
      Swal.fire({
        title: 'Success!',
        text: response.data.message || 'Referral payout saved successfully!',
        icon: 'success',
        confirmButtonText: 'OK',
        confirmButtonColor: '#214F7D',
      });

      // refresh all data after successful submission
      fetchPayoutSummary();
      fetchReferralSummary();
      fetchReferralPayoutDetails();

      setPaidAmount("");
      setRemarks("");
      setReceiptFile(null);
    } else {
      setAlert({ show: true, type: "error", message: response.data.message || "Failed to save referral payout." });
    }
  } catch (error) {
    console.error("handleSave error:", error);
    setAlert({ show: true, type: "error", message: "Failed to save referral payout. Please try again." });
  } finally {
    setLoading(false);
  }
};

  const readOnlyStyle = {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#f8f9fa',
    }
  };
const getPayoutStatus = () => {
  const pending = parseFloat(pendingAmount);
  const original = parseFloat(originalReferralAmount);
  if (original === 0) return "COMPLETED";
  if (pending === 0) return "COMPLETED";
  if (paidAmount && (parseFloat(paidAmount) * 100) >= pending) return "COMPLETED";
  return "PENDING";
};
const getPayoutStatusColor = () => {
  return getPayoutStatus() === "COMPLETED" ? "success" : "warning";
};
  return (
    <Box sx={{ p: 4, background: "#f6f7fb", minHeight: "100vh" }}>

      {/* Top Summary Cards */}
      <Grid container spacing={3} mb={3}>
  <Grid item xs={12} md={6}>
    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary">UNIVERSAL REFERRAL COUNT</Typography>
        <Typography variant="h4" fontWeight="bold">{universalReferralCount}</Typography>  {/* ✅ was: payoutHistory.length */}
      </CardContent>
    </Card>
  </Grid>
  <Grid item xs={12} md={6}>
    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary">TOTAL REFERRALS</Typography>
        <Typography variant="h4" fontWeight="bold">${(totalReferralAmount/ 100).toLocaleString()}</Typography>  {/* ✅ was: currentMonthAmount */}
      </CardContent>
    </Card>
  </Grid>
</Grid>

      {/* Main Form Card */}
      <Card sx={{ borderRadius: 3, overflow: 'hidden' }}>
        {/* Card Header */}
        <Box sx={{ px: 3, py: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #eee' }}>
          <Typography variant="h6" fontWeight={600}>
            Current Month: {months.find(m => m.value === currentMonth.toString())?.label} {currentYear}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 600, color: '#495057' }}>PAYOUT STATUS:</Typography>
            <Chip
  label={getPayoutStatus()}
  color={getPayoutStatusColor()}
  size="small"
/>
          </Box>
        </Box>

        <CardContent sx={{ p: 3 }}>

          {/* ── Section 01: Referral Summary ── */}
          <Box sx={{ mb: 4 }}>
            <SectionHeader number={1} title="REFERRAL SUMMARY" />
            <Grid container spacing={3}  sx={{ flexWrap: 'nowrap' }}>
              <Grid item xs={4} sm={4}>
                <Typography variant="caption" sx={{ fontWeight: 600, color: '#6c757d', letterSpacing: 0.5, textTransform: 'uppercase' }}>
                  Monthly Count
                </Typography>
                <TextField
                  fullWidth
                  value={currentMonthReferrals || "0"}
                  InputProps={{ readOnly: true }}
                  sx={{ mt: 0.5, ...readOnlyStyle }}
                  size="small"
                />
              </Grid>
              <Grid item xs={4} sm={4}>
                <Typography variant="caption" sx={{ fontWeight: 600, color: '#6c757d', letterSpacing: 0.5, textTransform: 'uppercase' }}>
                  Referral Amount
                </Typography>
                <TextField
                  fullWidth
                  value={`$${(currentMonthAmount / 100).toLocaleString()}`}
                  InputProps={{ readOnly: true }}
                  sx={{ mt: 0.5, ...readOnlyStyle }}
                  size="small"
                />
              </Grid>
              <Grid item xs={4} sm={4}>
                <Typography variant="caption" sx={{ fontWeight: 600, color: '#6c757d', letterSpacing: 0.5, textTransform: 'uppercase' }}>
                  Previous Amount
                </Typography>
                <TextField
                  fullWidth
                  value={`$${(pendingAmount / 100).toLocaleString()}`}
                  InputProps={{ readOnly: true }}
                  sx={{ mt: 0.5, ...readOnlyStyle }}
                  size="small"
                />
              </Grid>
            </Grid>
          </Box>

          {/* ── Section 02: Payout Details ── */}
          <Box sx={{ mb: 4 }}>
            <SectionHeader number={2} title="PAYOUT DETAILS" />
            <Grid container spacing={3} sx={{ flexWrap: 'nowrap' }}>
  <Grid item xs={4}>
    <Typography variant="caption" sx={{ fontWeight: 600, color: '#6c757d', letterSpacing: 0.5, textTransform: 'uppercase' }}>
      Total Payout Amount
    </Typography>
    <TextField
      fullWidth
      value={`$${(pendingAmount / 100).toLocaleString()}`}
      InputProps={{ readOnly: true }}
      sx={{ mt: 0.5, ...readOnlyStyle }}
      size="small"
    />
  </Grid>
  <Grid item xs={4}>
    <Typography variant="caption" sx={{ fontWeight: 600, color: '#6c757d', letterSpacing: 0.5, textTransform: 'uppercase' }}>
      Actual Paid Amount
    </Typography>
   <TextField
  fullWidth
  placeholder="0.00"
  value={paidAmount}
  onChange={(e) => setPaidAmount(e.target.value)}
  type="number"
  disabled={!pendingAmount || parseFloat(pendingAmount) === 0}
  sx={{ mt: 0.5 }}
  size="small"
/>
  </Grid>
  <Grid item xs={4}>
    <Typography variant="caption" sx={{ fontWeight: 600, color: '#6c757d', letterSpacing: 0.5, textTransform: 'uppercase' }}>
      Audit Remark / TXN ID
    </Typography>
    <TextField
      fullWidth
      placeholder="e.g. TXN-2026-MAR-0045"
      value={remarks}
      onChange={(e) => setRemarks(e.target.value)}
      sx={{ mt: 0.5 }}
      size="small"
    />
  </Grid>
</Grid>
          </Box>

          {/* ── Section 03: Audit Action & Attachments ── */}
          <Box>
            <SectionHeader number={3} title="AUDIT ACTION & ATTACHMENTS" />
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                border: '1px solid #e0e0e0',
                borderRadius: 2,
                p: 2,
                backgroundColor: '#fff',
              }}
            >
              {/* Left: Document Info */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box
                  sx={{
                    width: 44, height: 44, borderRadius: 2,
                    backgroundColor: '#f0f4f8',
                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                  }}
                >
                  <DescriptionIcon sx={{ color: '#607d8b', fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="body2" fontWeight={600} color="#333">
                    {receiptFile ? receiptFile.name : 'Verification Document'}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {receiptFile ? `${(receiptFile.size / 1024).toFixed(1)} KB · Ready to submit` : 'Provide a valid proof of transfer for audit trail'}
                  </Typography>
                </Box>
              </Box>

              {/* Right: Buttons */}
              <Box sx={{ display: 'flex', gap: 1.5 }}>
                <Button
                  variant="outlined"
                  component="label"
                  startIcon={<CloudUploadIcon />}
                  sx={{
                    borderColor: '#bdbdbd',
                    color: '#495057',
                    textTransform: 'none',
                    fontWeight: 600,
                    borderRadius: '8px',
                    '&:hover': { borderColor: '#214F7D', color: '#214F7D', backgroundColor: '#f0f4f8' }
                  }}
                >
                  Attach Receipt
                  <input
                    type="file"
                    accept="image/*,.pdf,.doc,.docx"
                    onChange={(e) => setReceiptFile(e.target.files[0])}
                    hidden
                  />
                </Button>
                <Button
                  variant="contained"
                  onClick={handleSave}
                  disabled={loading}
                  startIcon={<CheckCircleIcon />}
                  sx={{
                    backgroundColor: '#e8531a',
                    textTransform: 'none',
                    fontWeight: 600,
                    borderRadius: '8px',
                    px: 3,
                    '&:hover': { backgroundColor: '#c94415' },
                    '&:disabled': { backgroundColor: '#f5a88a' }
                  }}
                >
                  {loading ? "Submitting..." : "Submit"}
                </Button>
              </Box>
            </Box>
          </Box>

          {alert.show && (
            <Alert severity={alert.type} sx={{ mt: 2 }} onClose={() => setAlert({ show: false, type: "", message: "" })}>
              {alert.message}
            </Alert>
          )}
        </CardContent>
      </Card>

      {/* Audit History Table */}
      <Card sx={{ mt: 4, borderRadius: 3 }}>
        <CardContent>
          <Typography variant="h6" mb={2} fontWeight={600}>Audit History</Typography>
          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead sx={{ backgroundColor: '#f8f9fa' }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 700 }}>Date</TableCell>
<TableCell sx={{ fontWeight: 700 }}>Time</TableCell>
<TableCell sx={{ fontWeight: 700 }}>Referrals</TableCell>
<TableCell sx={{ fontWeight: 700 }}>Referral Amount</TableCell>
<TableCell sx={{ fontWeight: 700 }}>Previous Amount</TableCell>
<TableCell sx={{ fontWeight: 700 }}>Actual Paid Amount</TableCell>
<TableCell sx={{ fontWeight: 700 }}>Remarks</TableCell>
<TableCell sx={{ fontWeight: 700 }}>Attachment</TableCell>
<TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
                </TableRow>
              </TableHead>
             <TableBody>
  {auditHistory.length > 0 ? (
    auditHistory.map((item, index) => (
      <TableRow key={index} hover>
       <TableCell>{item.created_at ? new Date(item.created_at).toLocaleDateString() : "N/A"}</TableCell>
<TableCell>
  {item.created_at ? new Date(item.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true }) : "N/A"}
</TableCell>
<TableCell>{item.peacekeeper_id || "N/A"}</TableCell>
<TableCell>${item.refferal_amount ? (item.refferal_amount / 100).toLocaleString() : "0.00"}</TableCell>
<TableCell>${item.pending_amount ? (item.pending_amount / 100).toLocaleString() : "0.00"}</TableCell>
<TableCell>${item.paid_amount ? (item.paid_amount / 100).toLocaleString() : "0.00"}</TableCell>
<TableCell>{item.remarks || "N/A"}</TableCell>
        <TableCell>
          {item.receipt_file_path ? (
           <Button
  size="small"
  variant="outlined"
  startIcon={<DescriptionIcon />}
  onClick={() => setPreviewFile(`https://peacekeeper.duredemos.com/${item.receipt_file_path.replace('/home/duredemopeace/serviceuat/', '')}`)}
  sx={{
    textTransform: 'none',
    fontSize: '0.75rem',
    borderColor: '#607d8b',
    color: '#607d8b',
    '&:hover': { borderColor: '#214F7D', color: '#214F7D' }
  }}
>
  View
</Button>
          ) : (
            <Typography variant="caption" color="text.secondary">No file</Typography>
          )}
        </TableCell>
        <TableCell>
         <Chip
  label={item.payout_status || "Pending"}
  color={
    (item.payout_status?.toUpperCase() === "COMPLETED" || 
     item.status?.toUpperCase() === "COMPLETED") ? "success" : "warning"
  }
  size="small"
/>
        </TableCell>
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell colSpan={9} sx={{ textAlign: 'center', color: '#999', py: 4 }}>
        No audit history available
      </TableCell>
    </TableRow>
  )}
</TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
      <Dialog open={Boolean(previewFile)} onClose={() => setPreviewFile(null)} maxWidth="md" fullWidth>
  <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    Receipt Preview
    <Button onClick={() => setPreviewFile(null)} sx={{ minWidth: 'auto', color: '#666' }}>✕</Button>
  </DialogTitle>
  <DialogContent sx={{ textAlign: 'center', p: 2 }}>
    {previewFile && (
      previewFile.match(/\.(jpg|jpeg|png|gif|webp)$/i) ? (
        <img src={previewFile} alt="Receipt" style={{ maxWidth: '100%', maxHeight: '70vh', borderRadius: 8 }} />
      ) : (
        <iframe src={previewFile} title="Receipt" style={{ width: '100%', height: '70vh', border: 'none' }} />
      )
    )}
  </DialogContent>
  <DialogActions>
    <Button href={previewFile} target="_blank" variant="outlined" sx={{ textTransform: 'none' }}>
      Open in New Tab
    </Button>
    <Button onClick={() => setPreviewFile(null)} variant="contained" sx={{ backgroundColor: '#214F7D', textTransform: 'none' }}>
      Close
    </Button>
  </DialogActions>
</Dialog>
    </Box>
  );
};

export default EntityReferralStatistics;